<div class="dfiltros">
  @if (titulo()) {
    <h2 class="dfiltros-titulo">{{ titulo() }}</h2>
  }
  <div class="dfiltros-controles">
    <div class="dfiltros-periodo">
      <ng-content select="[filtros-periodo]"></ng-content>
    </div>
    <div class="dfiltros-campos">
      <ng-content select="[filtros-campos]"></ng-content>
    </div>
    <div class="dfiltros-acciones">
      <ng-content select="[filtros-acciones]"></ng-content>
    </div>
  </div>
</div>
